import React from 'react';
import styles from './index.css';
import DataItem from './dataItem';
class DataBox extends React.PureComponent {
    render() {
        const { content } = this.props;
        return (React.createElement("div", { className: styles.data_box }, content.map((item, index) => (React.createElement(React.Fragment, { key: index },
            React.createElement(DataItem, { content: item }),
            index !== content.length - 1 ? React.createElement("div", { className: styles.devide }) : '')))));
    }
}
export default DataBox;
